import React from 'react';

export const TableHeader = ({ UImobile }) => (
    <thead className="kt-datatable__head">
    <tr className="kt-datatable__row">
        <th className={`kt-datatable__cell${UImobile.openSidebar ? ' openSidebar' : ''}`} width="180px">
            <span>Наименование</span>
        </th>
        <th className={`kt-datatable__cell${UImobile.openSidebar ? ' openSidebar' : ''}`} width="40px">
            <span></span>
        </th>
        <th className={`kt-datatable__cell${UImobile.openSidebar ? ' openSidebar' : ''}`} width="120px">
            <span>Количество</span>
        </th>
        <th className={`kt-datatable__cell${UImobile.openSidebar ? ' openSidebar' : ''}`} width="120px">
            <span>Цена</span>
        </th>
        <th className={`kt-datatable__cell${UImobile.openSidebar ? ' openSidebar' : ''}`} width="310px">
            <span>Сумма</span>
        </th>
        <th
            className={`kt-datatable__cell${UImobile.openSidebar ? ' openSidebar' : ''}`}
            width="180px"
            style={{textAlign: 'right'}}
        >
            <span>Сумма</span>
        </th>
    </tr>
    </thead>
);